import axios from 'axios'

export default axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'rem-api-username': process.env.VUE_APP_API_USERNAME,
    'rem-api-password': process.env.VUE_APP_API_PASSWORD,
    'rem-api-secretkey': process.env.VUE_APP_API_SECRETKEY,
  },
  // adapter: cache.adapter,
  transformRequest: [(data) => {
    return {
      ...data,
      projectid: process.env.VUE_APP_API_PROJECT_ID,
    }
  }, ...axios.defaults.transformRequest],
})
